import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXPackComponent } from './simple-icons-x-pack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXPackComponent ],
    exports:      [ SimpleIconsXPackComponent ],
    bootstrap:    []
})
export class SimpleIconsXPackModule {}
